// import Swiper from 'swiper';
// import 'remodal';

// スクロール
// var Ease = {
// 	easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
// };
// var duration = 500;
window.addEventListener('DOMContentLoaded', () => {
	// var smoothScrollTriggers = document.querySelectorAll('.anchor');
	// smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
	// 	smoothScrollTrigger.addEventListener('click', function (e) {
	// 		var href = smoothScrollTrigger.getAttribute('href');
	// 		var currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
	// 		var targetElement = document.getElementById(href.replace('#', ''));
	// 		if (targetElement) {
	// 			e.preventDefault();
	// 			e.stopPropagation();
	// 			var targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - 70;
	// 			var startTime = performance.now();
	// 			var loop = function (nowTime) {
	// 				var time = nowTime - startTime;
	// 				var normalizedTime = time / duration;
	// 				if (normalizedTime < 1) {
	// 					window.scrollTo(0, currentPostion + (targetPosition - currentPostion) * Ease.easeInOut(normalizedTime));
	// 					requestAnimationFrame(loop);
	// 				} else {
	// 					window.scrollTo(0, targetPosition);
	// 				}
	// 			};
	// 			requestAnimationFrame(loop);
	// 		}
	// 	});
	// });

	// スクロールアニメーション;
	funcAnim();
});

// window.addEventListener('scroll', () => {
// 	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
// 	let myMain = document.querySelectorAll('.area');
// 	for (let i = 0; i < myMain.length; i++) {
// 		let rect = myMain[i].getBoundingClientRect();
// 		let posiTop = rect.top + scrollTop - 60; // ターゲットがブラウザTOPに来たら
// 		// let posiMid = posiTop - window.innerHeight / 2; // ターゲットがブラウザMIDに来たら
// 		// let posiBtm = posiTop - window.innerHeight; // ターゲットがブラウザBOTOMに来たら
// 		let myHeight = myMain[i].clientHeight - 0;
// 		let position_bottom = posiTop + myHeight; // ターゲットが下からスクロールしたときに見える位置

// 		// ターゲットが来た時ときの動き
// 		if (scrollTop > posiTop && scrollTop < position_bottom) {
// 			document.querySelector('.side nav li:nth-child(' + [i + 1] + ')').classList.add('active');
// 			// console.log('きた');
// 		} else {
// 			// それ以外の動き
// 			document.querySelector('.side nav li:nth-child(' + [i + 1] + ')').classList.remove('active');
// 		}
// 	}
// });

// window.addEventListener('load', function () {
// 	// スライダー
// 	let slide = document.querySelectorAll('.slide');
// 	for (let i = 0; i < slide.length; i++) {
// 		const swiper = document.querySelectorAll('.slide .swiper-container')[i];
// 		new Swiper(swiper, {
// 			loop: true,
// 			spaceBetween: 20,
// 			// watchOverflow: true, // loopと併用不可
// 			// effect: 'fade',
// 			speed: 600,
// 			// autoplay: {
// 			// 	delay: 3000,
// 			// 	disableOnInteraction: false,
// 			// },
// 			pagination: {
// 				el: document.querySelectorAll('.slide .swiper-pagination')[i],
// 				type: 'bullets',
// 				clickable: true,
// 			},
// 			navigation: {
// 				nextEl: document.querySelectorAll('.slide .swiper-button-next')[i],
// 				prevEl: document.querySelectorAll('.slide .swiper-button-prev')[i],
// 			},
// 		});
// 	}
// });

const funcAnim = () => {
	const progressItems = document.querySelectorAll('.anim');
	const observeAction = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// console.log('きた');
				entry.target.classList.add('active');
			}
			// else {
			// 	// console.log('こない');
			// 	entry.target.classList.remove('active');
			// }
		});
	};

	const options = {
		// root: root,
		rootMargin: '0px 0px -10% 0px',
	};

	const obsever = new IntersectionObserver(observeAction, options);

	progressItems.forEach((target) => {
		obsever.observe(target);
	});
};
